/* __next_internal_client_entry_do_not_use__ NotificationPreview auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Flex, Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackRetailerNotificationsP0NudgeClick } from "@faire/web-api--source/events/retailerNotifications/click/p0Nudge";
import { trackRetailerNotificationsP0NudgeDismiss } from "@faire/web-api--source/events/retailerNotifications/dismiss/p0Nudge";
import { trackRetailerNotificationsP0NudgeView } from "@faire/web-api--source/events/retailerNotifications/view/p0Nudge";
import isUndefined from "lodash/isUndefined";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { useNotificationPreview } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotificationPreview";
import { useSetNotificationState } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useSetNotificationState";
import { useHeaderPriorityStore } from "@faire/retailer/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { useIsHeaderDropdownVisible } from "@faire/retailer/components/HeaderPriorityRenderer/useIsHeaderDropdownVisible";
import { setTimeoutIfPossible } from "@faire/retailer/lib/async-functions/setTimeoutIfPossible";
import { isWebView } from "@faire/retailer/lib/user-agent/isWebView";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";
import { ANIMATION_TIME } from "./consts";
import { useIsOnNotificationsPage } from "./hooks/useIsOnNotificationsPage";
import { useNotificationMessagePath } from "./hooks/useNotificationMessagePath";
export var NotificationPreview = function() {
    var _notificationPreview_message, _notificationPreview_message1, _notificationPreview_message2;
    var _useHeaderPriorityStore = _sliced_to_array(useHeaderPriorityStore([
        "isNotificationPreviewVisible"
    ]), 2), isNotificationPreviewVisible = _useHeaderPriorityStore[0].isNotificationPreviewVisible, setHeaderPriorityStore = _useHeaderPriorityStore[1];
    var isAnyHeaderDropdownVisible = useIsHeaderDropdownVisible().isAnyHeaderDropdownVisible;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var notificationPreview = useNotificationPreview();
    var isOnNotificationsPage = useIsOnNotificationsPage();
    var messagePath = useNotificationMessagePath(notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.message);
    var _notificationPreview_token;
    var _useSetNotificationState = useSetNotificationState((_notificationPreview_token = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.token) !== null && _notificationPreview_token !== void 0 ? _notificationPreview_token : ""), setNotificationHasBeenViewed = _useSetNotificationState.setNotificationHasBeenViewed, setNudgeHasBeenDismissed = _useSetNotificationState.setNudgeHasBeenDismissed;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isSSR = useIsSSR();
    var _useState = _sliced_to_array(useState(false), 2), animateOut = _useState[0], setAnimateOut = _useState[1];
    var ref = useDoActionWhenVisible(function() {
        var _notificationPreview_message;
        var _notificationPreview_type, _notificationPreview_message_text, _notificationPreview_client_identifier;
        trackRetailerNotificationsP0NudgeView((_notificationPreview_type = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.type) !== null && _notificationPreview_type !== void 0 ? _notificationPreview_type : "", (_notificationPreview_message_text = notificationPreview === null || notificationPreview === void 0 ? void 0 : (_notificationPreview_message = notificationPreview.message) === null || _notificationPreview_message === void 0 ? void 0 : _notificationPreview_message.text) !== null && _notificationPreview_message_text !== void 0 ? _notificationPreview_message_text : "", (_notificationPreview_client_identifier = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.client_identifier) !== null && _notificationPreview_client_identifier !== void 0 ? _notificationPreview_client_identifier : "");
    });
    var handleAnimateOutNudge = useCallback(function() {
        setAnimateOut(true);
        setTimeoutIfPossible(function() {
            setHeaderPriorityStore({
                isNotificationPreviewVisible: false
            });
            setAnimateOut(false);
        }, ANIMATION_TIME);
    }, [
        setHeaderPriorityStore
    ]);
    var handleDismiss = useCallback(function() {
        var _notificationPreview_message;
        var _notificationPreview_type, _notificationPreview_message_text, _notificationPreview_client_identifier;
        trackRetailerNotificationsP0NudgeDismiss((_notificationPreview_type = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.type) !== null && _notificationPreview_type !== void 0 ? _notificationPreview_type : "", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", (_notificationPreview_message_text = notificationPreview === null || notificationPreview === void 0 ? void 0 : (_notificationPreview_message = notificationPreview.message) === null || _notificationPreview_message === void 0 ? void 0 : _notificationPreview_message.text) !== null && _notificationPreview_message_text !== void 0 ? _notificationPreview_message_text : "", (_notificationPreview_client_identifier = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.client_identifier) !== null && _notificationPreview_client_identifier !== void 0 ? _notificationPreview_client_identifier : "");
        setNudgeHasBeenDismissed();
        handleAnimateOutNudge();
    }, [
        handleAnimateOutNudge,
        notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.client_identifier,
        notificationPreview === null || notificationPreview === void 0 ? void 0 : (_notificationPreview_message = notificationPreview.message) === null || _notificationPreview_message === void 0 ? void 0 : _notificationPreview_message.text,
        notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.type,
        retailerToken,
        setNudgeHasBeenDismissed
    ]);
    var handleClick = function() {
        var _notificationPreview_message;
        var _notificationPreview_type, _notificationPreview_client_identifier;
        trackRetailerNotificationsP0NudgeClick((_notificationPreview_type = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.type) !== null && _notificationPreview_type !== void 0 ? _notificationPreview_type : "", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", notificationPreview === null || notificationPreview === void 0 ? void 0 : (_notificationPreview_message = notificationPreview.message) === null || _notificationPreview_message === void 0 ? void 0 : _notificationPreview_message.text, (_notificationPreview_client_identifier = notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.client_identifier) !== null && _notificationPreview_client_identifier !== void 0 ? _notificationPreview_client_identifier : "");
        setNotificationHasBeenViewed();
        setNudgeHasBeenDismissed();
        handleAnimateOutNudge();
    };
    useEffect(function() {
        if (isAnyHeaderDropdownVisible && notificationPreview) {
            handleAnimateOutNudge();
        } else if (!isAnyHeaderDropdownVisible && notificationPreview && isUndefined(notificationPreview === null || notificationPreview === void 0 ? void 0 : notificationPreview.nudge_dismissed_at)) {
            setHeaderPriorityStore({
                isNotificationPreviewVisible: true
            });
        }
    }, [
        handleAnimateOutNudge,
        isAnyHeaderDropdownVisible,
        notificationPreview,
        setHeaderPriorityStore
    ]);
    if (!isNotificationPreviewVisible || isUndefined(notificationPreview) || isOnNotificationsPage || isSSR || isWebView()) {
        return null;
    }
    var _notificationPreview_message_prefix_text_color_hex;
    return /*#__PURE__*/ _jsxs(AnimatedPreviewWrapper, {
        $animateOut: animateOut,
        justify: "flex-end",
        align: "flex-start",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(LinkWrapper, {
                to: messagePath,
                onClick: handleClick,
                "data-test-id": "notification-preview-".concat(notificationPreview.type),
                children: /*#__PURE__*/ _jsx(Row, {
                    justify: "space-between",
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        variant: "paragraphSansMedium",
                        children: [
                            ((_notificationPreview_message1 = notificationPreview.message) === null || _notificationPreview_message1 === void 0 ? void 0 : _notificationPreview_message1.prefix) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Span, {
                                        variant: "paragraphSansMedium",
                                        color: "#".concat((_notificationPreview_message_prefix_text_color_hex = notificationPreview.message.prefix.text_color_hex) !== null && _notificationPreview_message_prefix_text_color_hex !== void 0 ? _notificationPreview_message_prefix_text_color_hex : "E65126"),
                                        children: notificationPreview.message.prefix.text
                                    }),
                                    " "
                                ]
                            }) : null,
                            notificationPreview === null || notificationPreview === void 0 ? void 0 : (_notificationPreview_message2 = notificationPreview.message) === null || _notificationPreview_message2 === void 0 ? void 0 : _notificationPreview_message2.text
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(IconWrapper, {
                "aria-label": strictLocalize({
                    id: "diVxpc",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "close button"
                        }
                    ]
                }),
                onClick: handleDismiss,
                variant: "tertiary",
                children: /*#__PURE__*/ _jsx(StyledClose, {
                    fontSize: "13px",
                    strokeWidth: 2
                })
            })
        ]
    });
};
var slideInFromRight = keyframes([
    "from{transform:translateX(100%);opacity:0;}to{transform:translateX(0);opacity:1;}"
]);
var slideOutToRight = keyframes([
    "from{transform:translateX(0);opacity:1;}to{transform:translateX(100%);opacity:0;}"
]);
var StyledClose = styled(Close).withConfig({
    componentId: "sc-2a2076a0-0"
})([
    "&:hover{cursor:pointer;}"
]);
var IconWrapper = styled(Button).withConfig({
    componentId: "sc-2a2076a0-1"
})([
    "background:",
    ";border-radius:50%;height:35px;width:35px;padding:10px;position:relative;top:16px;right:8px;&:hover{background:",
    ";}"
], Core.surface.inverse, Core.surface.subdued);
var PreviewWrapper = styled(Flex).withConfig({
    componentId: "sc-2a2076a0-2"
})([
    "position:absolute;right:0px;width:100%;box-shadow:-5px 10px 10px 0px rgba(0,0,0,0.15);background:",
    ";z-index:300;",
    "{max-width:392px;}&:hover:not(:has(",
    ":hover)){background:",
    ";}"
], Core.surface.inverse, responsiveMediaQueries.tabletAndAbove, IconWrapper, Core.surface.subdued);
var LinkWrapper = styled(Link).withConfig({
    componentId: "sc-2a2076a0-3"
})([
    "padding:20px;display:flex;width:calc(100% - 35px);"
]);
var AnimatedPreviewWrapper = styled(PreviewWrapper).withConfig({
    componentId: "sc-2a2076a0-4"
})([
    "animation:",
    ";"
], function(props) {
    return props.$animateOut ? css([
        "",
        " 300ms forwards"
    ], slideOutToRight) : css([
        "",
        " 300ms forwards"
    ], slideInFromRight);
});
